import React, { useState } from 'react';
import { Container, Row, Col, Form, Button } from 'react-bootstrap';
import Select from 'react-select';

const UpdateBankDetail = () => {
  const [companyId, setCompanyId] = useState('');
  const [accountHolderName, setAccountHolderName] = useState('');
  const [accountNumber, setAccountNumber] = useState('');
  const [branch, setBranch] = useState('');
  const [ifscCode, setIfscCode] = useState('');

  const handleCompanyChange = (selectedCompany) => {
    setCompanyId(selectedCompany ? selectedCompany.value : '');
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log({
      companyId,
      accountHolderName,
      accountNumber,
      branch,
      ifscCode,
    });
  };

  return (
    <Container className="form-container">
      <h2>Update Bank Details</h2>
      <Form onSubmit={handleSubmit}>
        {/* Company ID */}
        <Row className="mb-3">
          <Col>
            <Form.Label>Company ID</Form.Label>
            <Select
              options={[
                { value: 'company1', label: 'Company 1' },
                { value: 'company2', label: 'Company 2' },
                { value: 'company3', label: 'Company 3' },
              ]}
              value={companyId ? { value: companyId, label: companyId } : null}
              onChange={handleCompanyChange}
              isClearable
              placeholder="Select Company"
              required
            />
          </Col>
        </Row>

        {/* Account Holder Name */}
        <Row className="mb-3">
          <Col>
            <Form.Label>Account Holder Name</Form.Label>
            <Form.Control
              type="text"
              value={accountHolderName}
              onChange={(e) => setAccountHolderName(e.target.value)}
              required
            />
          </Col>
        </Row>

        {/* Account Number */}
        <Row className="mb-3">
          <Col>
            <Form.Label>Account Number</Form.Label>
            <Form.Control
              type="text"
              value={accountNumber}
              onChange={(e) => setAccountNumber(e.target.value)}
              required
              maxLength={20}  // Account number max length (adjustable)
              pattern="[0-9]{1,20}"  // Account number pattern (adjust as needed)
              title="Please enter a valid account number"
            />
          </Col>
        </Row>

        {/* Branch */}
        <Row className="mb-3">
          <Col>
            <Form.Label>Branch</Form.Label>
            <Form.Control
              type="text"
              value={branch}
              onChange={(e) => setBranch(e.target.value)}
              required
            />
          </Col>
        </Row>

        {/* IFSC Code */}
        <Row className="mb-3">
          <Col>
            <Form.Label>IFSC Code</Form.Label>
            <Form.Control
              type="text"
              value={ifscCode}
              onChange={(e) => setIfscCode(e.target.value)}
              required
              maxLength={11}  // IFSC code length
              pattern="[A-Za-z]{4}[0-9]{7}"  // IFSC code pattern
              title="Please enter a valid IFSC code"
            />
          </Col>
        </Row>

        <Button type="submit" variant="primary">Submit</Button>
      </Form>
    </Container>
  );
};

export default UpdateBankDetail;
